module.exports = "/images/favicondeliveryman.jpg";